/* eslint-disable max-len */
export default {
  common: {
    PartI: "個人資料",
    PartIcontent: "個人資料",
    PartII: "詳細列明現金或無記名可轉讓票據的資料及所有人之聲明",
    PartIIcontent: "詳細列明現金或無記名可轉讓票據的資料及所有人之聲明",
    PartIII: "現金及/或無記名可轉讓票據的所有人身份資料 ( 如不屬聲明人所有 )",
    // PartIIIcontent: "現金及/或無記名可轉讓票據的所有人身份資料 ( 如不屬聲明人所有 )",
    PartIIIcontent: "",
    PartIV: "聲明",
    EntryFrom: "入境啟程地",
    or: "或",
    ExitTo: "出境目的地",
    Name: "姓名",
    Gender: "性別",
    Nationality: "國籍",
    PlaceofBirth: "出生地",
    DateofBrith: "出生日期",
    TravelDocumentType: "證件類別",
    TravelDocumentNumber: "證件號碼",
    PlaceofIssue: "簽發地",
    Permanentaddressandtelephonecontactnumber: "永久居所住址及聯絡電話",
    Currency: "現金",
    Travellerscheque: "旅行支票",
    Cheque: "支票",
    Billofexchange: "滙票",
    MoneyOrder: "付款委託書",
    PromissoryNote: "本票",
    Others: "其他",
    Currencyname: "貨幣名稱",
    Amounttonearestwholenumber: "數額 (最接近的整數)",
    Doesthedeclarantownthisitem: "此項目屬於聲明人所有",
    placeholder: "請輸入內容",
    Yes: "是",
    No: "否",
    theownershouldbeidentifiedontheappropriatefieldofPartIII: "必须在此项下方指出其所有人",
    LegalPersonCorporatename: "名稱 (法人)",
    IndividualName: "姓名 (自然人)",
    M: "男",
    F: "女",
    Address: "法人住所 / 自然人永久居所住址",
    item1: "第一項",
    item2: "第二項",
    item3: "第三項",
    item4: "第四項",
    item5: "第五項",
    item6: "第六項",
    item7: "第七項",
    item8: "第八項",
    item9: "第九項",
    item10: "第十項",
    item11: "第十一項",
    item12: "第十二項",
    item13: "第十三項",
    item14: "第十四項",
    item15: "第十五項",
    item16: "第十六項",
    item17: "第十七項",
    item18: "第十八項",
    item19: "第十九項",
    item20: "第二十項",
    item21: "第二十一項",
    item22: "第二十二項",
    item23: "第二十三項",
    item24: "第二十四項",
    item25: "第二十五項",
    item26: "第二十六項",
    item27: "第二十七項",
    item28: "第二十八項",
    item29: "第二十九項",
    item30: "第三十項",
    // 剩下為電腦翻譯
    Thesavewassuccessful: "保存成功",
    Pleasemakesuretoreadthedeclaration: "請確認已閱讀《申報須知》",
    Youcansaveuptotenrecords: "最多只能保存十筆記錄",
    Pleasechoosetodeletetheitem: "請選擇刪除項",
    Whethertoconfirmthedeletion: "是否確認刪除",
    yyyyMMdd: "yyyy 年 MM 月 dd 日",
    YearMonthDay: "(年/月/日)",
    Pleaseselect: "請選擇（支持直接輸入關鍵字檢索）",
    Pleaseenteryourcontactnumber: "請輸入您的聯繫電話",
    Cannotseeclearly: "看不清楚？換一張",
    Keepthefilinginformation: "保存申報資料到本機，以便下次重新申報",
    Ideclare: "本人聲明已閱讀《申報須知》及填寫的資料均屬實和完整",
    verificationcode: "請輸入驗證碼",
    // pleasekeepthisQRcode: "本人需持此二維碼到海關時，向關員出示此碼進行檢測核驗，請保管好此二維碼，以免為自己出行帶來不便之處",
    pleasekeepthisQRcode: "請向海關關員出示二維碼，完成申報程序",
    QRcodepicturesarerequired: "請保存二維碼以便完成申報程序，如已截圖，可關閉本提示",
    Savethepicture: "保存二維碼",
    Stillexit: "已截圖，關閉",
    Statement: "聲明",
    details: "最少填寫1項 最多可填寫30項",
    required: "必填內容",
    del: "刪除",
    add: "增加",
    confirmDelete: "確定刪除",
    warn: "提示",
    confirm: "確定",
    cancel: "取消",
    Pleaseentertheareacode: "請輸入區號",
    Pleaseenterthefirstitem: "請至少完成第一項",
    Pleaseamount1: "請填寫第二部分第一項“數額”",
    Pleaseamount2: "請填寫第二部分第二項“數額”",
    Pleaseamount3: "請填寫第二部分第三項“數額”",
    amount: "請填寫數額",
    currencyName: "請填寫貨幣名稱",

    Pleasecurrency1: "請填寫第二部分第一項“貨幣名稱”",
    Pleasecurrency2: "請填寫第二部分第二項“貨幣名稱”",
    Pleasecurrency3: "請填寫第二部分第三項“貨幣名稱”",

    Pleasewhether1: "請填寫第二部分第一項“屬於聲明人所有”",
    Pleasewhether2: "請填寫第二部分第二項“屬於聲明人所有”",
    Pleasewhether3: "請填寫第二部分第三項“屬於聲明人所有”",

    Pleasecurrencytype1: "請填寫第二部分第一項貨幣類型",
    Pleasecurrencytype2: "請填寫第二部分第二項貨幣類型",
    Pleasecurrencytype3: "請填寫第二部分第三項貨幣類型",
    PleasePartIII1: "請填寫第三部分第一項",
    PleasePartIII2: "請填寫第三部分第二項",
    PleasePartIII3: "請填寫第三部分第三項",
    PleasePartpersonIII1: "請填寫第三部分第一項“名稱(法人)”或“姓名(自然人)”",
    PleasePartpersonIII2: "請填寫第三部分第二項“名稱(法人)”或“姓名(自然人)”",
    PleasePartpersonIII3: "請填寫第三部分第三項“名稱(法人)”或“姓名(自然人)”",
    PleasePartaddressIII1: "請填寫第三部分第一項“法人住所/自然人永久居所住址”",
    PleasePartaddressIII2: "請填寫第三部分第二項“法人住所/自然人永久居所住址”",
    PleasePartaddressIII3: "請填寫第三部分第三項“法人住所/自然人永久居所住址”",
    Pleaseentertheverificationcode: "請輸入驗證碼",
    Personaldata: "請完成 第一部分 - 個人資料",
    Whethertoconfirmtheremoval: "是否移除快速申報記錄？",
    Thedeletionwassuccessful: "刪除成功",
    Is: "是",
    Save: "保存二維碼",
    Cancel: "取消",
    Areyousure: "關閉",
    Code: "區號",
    aboutus: "關於我們",
    Contactus: "聯絡我們",
    Useandprivacypolicy: "使用及隱私條款",
    Addthenextitem: "增加",
    Pleaseenteryourplaceofentry: "請輸入您的入境啟程地",
    Pleaseenteryourexitdestination: "請輸入您的出境目的地",
    Pleaseenteryourname: "請輸入您的姓名",
    Pleaseenteryournationality: "請輸入您的國籍",
    Pleaseenteryourplaceofbirth: "請輸入您的出生地",
    Pleaseselectyourdateofbirth: "請選擇您的出生日期",
    Pleaseselectyourdocumentcategory: "請選擇您的證件類別",
    PleaseenteryourIDnumber: "請輸入您的證件號碼",
    Pleaseenteryourplaceofissue: "請輸入您的簽發地",
    Pleaseenteryourpermanentresidenceaddress: "請輸入您的永久居所住址",
    Pleaseenteryourareacode: "請輸入您的區號",
    Pleaseselectthecurrencytype: "請選擇貨幣類型",
    Pleaseenter: "請輸入",
    Pleaseselectyourcurrencyname: "請選擇您的貨幣名稱",
    Pleaseentertheamount: "請輸入數額(最接近整數)",
    Pleaseenterthepermanentresidenceaddressofthelegalentitynaturalperson: "請輸入法人住所/自然人永久居住住址",
    Pleasepresstheicontoentertheverificationcode: "請依顯示輸入驗證碼",
    Delete: "刪除",
    Pleaseselectenteringorleaving: "請選擇您是入境或出境",
    Pleaseselectenteringorleavings: "請選擇入境或出境",
    Immigration: "入境",
    Exit: "出境",
    Permanentresidenceaddress: "永久居所住址",
    Contactnumber: "聯絡電話",
    Stepup: "上一步",
    Nextstep: "下一步",
    tishi: "請完成個人資料",
    Submit: "提交",
    Whatyouneedtoknowtodeclare: "申報須知",
    Thesubmissionwassuccessful: "提交成功",
    Pleaseselectthefiler: "或選擇申報紀錄",
    Declare: "申報",
    Declares: "再次申報",
    Tips: "提示",
    Carryingcashandnameless: "攜帶現金和無記名可轉讓票據出入境網上電子申報平台",
    OK: "確定",
    Close: "關閉",
    CustomsoftheMacaoSpecialAdministrativeRegion: "澳門特別行政區海關",
    AddressMacau: "地址：氹仔北安碼頭大馬路北安碼頭三巷澳門海關總部大樓",
    Email: "電子郵箱",
    Phone: "電話",
    Fax: "傳真",
    Carrycashandnamelessnegotiableinstruments: "攜帶現金和無記名可轉讓票據",
    Declarationofentryandexit: "出入境申報書",
    Declarationofentryandexitwithcashandnamelessnegotiableinstruments: "攜帶現金和無記名可轉讓票據出入境申報書",
    Reset: "重置",
    Filer: "申報人",
    saveCode: "保存二維碼",
    failureCode: "二維碼已失效",
    edit: "再次申報",
    efficacy: "已失效",
    Themainresponsibilities: "主要職責",
    synchronizationText: "同第一项",
    cancelSynchronizationText: "取消同第一项",
    submitL: "正在提交中請稍後",
    2020: "2020 澳門海關 版權所有",
    rujin: "請填寫起源地或目的地",
    names: "請填寫姓名",
    Genders: "請選擇性別",
    Nationalitys: "請選擇國籍",
    birthplaces: "請填寫出生地",
    birthTimes: "請選擇出生日期",
    documentTypes: "請選擇證件類別",
    documentNums: "請填寫證件號碼",
    issues: "請填寫簽發地",
    addresss: "請填寫永久居所住址",
    phones: "請填寫電話號碼",
    tis: "請選擇申報紀錄信息"
  }
};